// extracted by mini-css-extract-plugin
export var numpadContainer = "_od-1";
export var phoneButton = "_od-0";